import styled, { css } from "styled-components";

export const headerMobileHeight = 72;

export const HeaderMobile = styled.header`
  position: fixed;
  z-index: 1090;
  top: 0;
  left: 0;
  display: flex;
  width: 100%;
  height: ${headerMobileHeight}px;
  justify-content: space-between;
  padding: 0 12px;
  align-items: center;
  background-color: ${({ theme }) => theme.palette.neutral.lightest};

  img {
    object-fit: contain;
    height: 36px;
    width: 120px;
    cursor: pointer;
  }

  .btn-menu {
    position: relative;
    z-index: 4;
    width: 32px;
    height: 22px;

    span {
      width: 100%;
      height: 4px;
      border-radius: 6px;
      position: absolute;
			z-index: 0;
			left: 0;
			transition: all 0.3s ease 0s;
			background-color: #5A89E1;

			&:nth-child(1) {
				top: 0;
			}

			&:nth-child(2) {
				top: 50%;
				transform: translateY(-50%);
			}

			&:nth-child(3) {
				bottom: 0;
			}
    }

    ${props => props.openMenu && css`
      span {
        background-color: #fff;
      }
      span:nth-child(1) {
        top: 48%;
        transform: rotate(45deg);
      }
      span:nth-child(2) {
        opacity: 0;
      }
      span:nth-child(3) {
        top: 48%;
        transform: rotate(-45deg);
      }
    `}
  }

  .nav-menu {
    position: absolute;
    z-index: 2;
    top: 0;
    left: 0;
    width: 100%;
    padding: 80px 20px 40px;
    background-color: #3f73f0;
    transition: all 0.3s ease 0s;

    ${props => !props.openMenu && css`
      transform: translate3d(100%, 0, 0);  
    `}

    .menu {
      list-style: none;
      text-align: right;
      color: #fff;

      li:not(:first-child) {
        margin-top: 12px;
      }

      a {
        display: inline-block;
        padding: 2px;
      }
    }
  }
`;
